var _style, _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bnb",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#f0b90b;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 250,0 C 388.08093,0 500,111.91907 500,250 500,388.08093 388.08093,500 250,500 111.91907,500 0,388.08093 0,250 0,111.91907 111.91907,0 250,0 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 137.39984,250 0.18029,66.10577 56.16987,33.05288 v 38.70193 L 104.70753,335.63702 V 230.66907 Z m 0,-66.10577 v 38.52164 L 104.6875,203.0649 v -38.52163 l 32.71234,-19.35096 32.8726,19.35096 z m 79.80769,-19.35096 32.71234,-19.35096 32.8726,19.35096 -32.8726,19.35096 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 161.03766,302.40385 V 263.70192 L 193.75,283.05288 v 38.52164 z m 56.16987,60.61698 32.71234,19.35096 32.8726,-19.35096 v 38.52164 l -32.8726,19.35096 -32.71234,-19.35096 z m 112.5,-198.47756 32.71234,-19.35096 32.8726,19.35096 v 38.52163 l -32.8726,19.35097 V 183.89423 Z M 362.41987,316.10577 362.60016,250 395.3125,230.64904 v 104.96795 l -89.04247,52.22355 v -38.70192 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 338.96233,302.40384 306.25,321.57451 v -38.52163 l 32.71233,-19.35096 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 338.96234,197.59615 0.18029,38.70193 -56.33013,33.05288 v 66.26603 l -32.71234,19.17067 -32.71234,-19.17067 v -66.26603 l -56.33013,-33.05288 v -38.70193 l 32.85257,-19.35096 55.98958,33.21314 56.33013,-33.21314 32.87259,19.35096 z M 161.03766,131.51042 249.91987,79.106571 338.96234,131.51042 306.25,150.86138 249.91987,117.64824 193.75,150.86138 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.ade58117024c054423da944e2851d37f.svg";
export { ForwardRef as ReactComponent };